import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

const ThemeContext = createContext();

export const ThemeProviderComponent = ({ children }) => {
    const [mode, setMode] = useState('system'); // Default je 'system'

    // Proverava da li postoji tema u localStorage i postavlja default ako ne postoji
    useEffect(() => {
        const savedMode = localStorage.getItem('theme');
        if (savedMode) {
            setMode(savedMode);
        } else {
            localStorage.setItem('theme', 'system'); // Postavi podrazumevani mod
        }
    }, []);
    
    const getSystemTheme = () => {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    };

    const getActiveMode = () => (mode === 'system' ? getSystemTheme() : mode);

    const applyThemeVariables = (appliedMode) => {
        const root = document.documentElement;
        if (appliedMode === 'light') {
            root.style.setProperty('--table-bg-odd', '#f9f9f9');
            root.style.setProperty('--table-bg-even', '#e0e0e0');
            root.style.setProperty('--table-header-bg', '#b0b0b0');
            root.style.setProperty('--contrast-color', '#000');

        } else if (appliedMode === 'dark') {
            root.style.setProperty('--table-bg-odd', '#333');
            root.style.setProperty('--table-bg-even', '#444');
            root.style.setProperty('--table-header-bg', '#555');
            root.style.setProperty('--contrast-color', '#fff');
        }
    };

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: getActiveMode(),
                    primary: {
                        main: '#4CAF50', // Glavna boja
                    },
                },
            }),
        [mode]
    );

    const toggleTheme = (selectedMode) => {
        setMode(selectedMode);
        localStorage.setItem('theme', selectedMode);
    };

    useEffect(() => {
        const currentMode = getActiveMode();
        applyThemeVariables(currentMode);

        const handleSystemThemeChange = (e) => {
            if (mode === 'system') {
                applyThemeVariables(e.matches ? 'dark' : 'light');
            }
        };

        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        mediaQuery.addEventListener('change', handleSystemThemeChange);

        return () => {
            mediaQuery.removeEventListener('change', handleSystemThemeChange);
        };
    }, [mode]);

    return (
        <ThemeContext.Provider value={{ mode, toggleTheme }}>
            <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    return useContext(ThemeContext);
};
